import React from 'react';
import PropTypes from 'prop-types';
import { Button, Badge } from 'react-bootstrap';
import { FaFilter } from 'react-icons/fa';

const TarifariosFiltersButton = ({ onOpenFilters, activeFiltersCount = 0 }) => {
    return (
        <Button 
            variant="outline-primary" 
            onClick={onOpenFilters}
            className="d-flex align-items-center"
        >
            <FaFilter className="me-2" />
            Filtros
            {activeFiltersCount > 0 && (
                <Badge bg="primary" className="ms-2">
                    {activeFiltersCount}
                </Badge>
            )}
        </Button>
    );
};

TarifariosFiltersButton.propTypes = {
    onOpenFilters: PropTypes.func.isRequired,
    activeFiltersCount: PropTypes.number
};

export default TarifariosFiltersButton;
